import { useCallback, useRef } from 'preact/hooks';

/**
 * A function with one identity for the component's lifetime that always calls the latest
 * `fn` (#1170): the Preact counterpart of React's `useEffectEvent`. Use it when an effect
 * calls a prop callback, or reads a value, that must not re-run the effect. List the
 * returned function in the dependency array; it never changes. Not for calls during render.
 */
export function useEventCallback<A extends unknown[], R>(fn: (...args: A) => R): (...args: A) => R {
    const latest = useRef(fn);
    // Assigned during render, so a child's effect that runs before this component's effects sees it.
    latest.current = fn;
    return useCallback((...args: A) => latest.current(...args), []);
}
